import { gql, useMutation } from '@apollo/client'

import {
  type ValidateCpfMutation,
  type ValidateCpfMutationVariables,
} from './__generated__/use-validate-cpf.graphql'

export const VALIDATE_CPF_MUTATION = gql`
  mutation ValidateCpf($input: ValidateCPFInput!) {
    validateCPF(input: $input) {
      profile {
        id
        pid
        isCpfValid
      }
    }
  }
`

interface ValidateCPFProps {
  cpf: string
  birthDate: Date
  documentData?: string
  documentName?: string
  matchValidationFirst?: boolean
  saveCpfDataOnError?: boolean
  origin: string
}

export const useValidateCPF = () => {
  const [validateCPF] = useMutation<ValidateCpfMutation, ValidateCpfMutationVariables>(
    VALIDATE_CPF_MUTATION
  )

  return async ({
    cpf,
    birthDate,
    documentData,
    documentName,
    matchValidationFirst = true,
    saveCpfDataOnError = false,
    origin,
  }: ValidateCPFProps) => {
    const documentVariables = documentData && documentName ? { documentData, documentName } : {}
    const variables = {
      input: {
        cpf,
        birthdate: birthDate.getTime(),
        matchValidationFirst,
        saveCpfDataOnError,
        origin,
        ...documentVariables,
      },
    }

    return validateCPF({
      variables,
      fetchPolicy: 'network-only',
    }).then(({ data }) => data)
  }
}
